import React from 'react'
import { numberWithCommas } from '../../helpers/helpers'
import { FormattedData, State } from '../../types'
import { DirectionArrow } from '../shared/DirectionArrow'
import {
    DifferenceInCases,
    StateLabel,
    StyledFlexTable,
    StyledTableCell,
    StyledTitle,
    StyledTitleWrap,
} from './JabTracker.styled'
export function ActiveCasesTable({
    data,
    type,
}: {
    data: FormattedData
    type?: 'large' | 'small'
}) {
    return (
        <>
            <StyledTitleWrap type={type}>
                <StyledTitle>Active Cases</StyledTitle>
                <p>Local active cases today</p>
            </StyledTitleWrap>
            <StyledFlexTable type={type}>
                {Object.keys(data).map((key) => {
                    const stateData = data[key as State]
                    const caseDirection =
                        stateData.cases.dailyDifference > 1 ? 'up' : 'down'
                    // Remove total count from list on small version
                    if (type === 'small' && key === 'AUS') {
                        return <span key="AUS"></span>
                    }
                    return (
                        <StyledTableCell key={key}>
                            <StateLabel>
                                {key === 'AUS' ? 'Total' : key}
                            </StateLabel>
                            <span>
                                {numberWithCommas(stateData.cases.dailyActive)}
                            </span>
                            {stateData.cases.dailyActive !== 0 && (
                                <DifferenceInCases direction={caseDirection}>
                                    {DirectionArrow({
                                        direction: caseDirection,
                                    })}
                                    {stateData.cases.dailyDifference}
                                </DifferenceInCases>
                            )}
                        </StyledTableCell>
                    )
                })}
            </StyledFlexTable>
            {/* show total case count underneath others on small version */}
            {type === 'small' && (
                <StyledTableCell>
                    <StateLabel>Total</StateLabel>
                    <span>{numberWithCommas(data.AUS.cases.dailyActive)}</span>
                    {data.AUS.cases.dailyActive !== 0 && (
                        <DifferenceInCases
                            direction={
                                data.AUS.cases.dailyDifference > 1
                                    ? 'up'
                                    : 'down'
                            }
                        >
                            {DirectionArrow({
                                direction:
                                    data.AUS.cases.dailyDifference > 1
                                        ? 'up'
                                        : 'down',
                            })}
                            {data.AUS.cases.dailyDifference}
                        </DifferenceInCases>
                    )}
                </StyledTableCell>
            )}
        </>
    )
}
